interface FieldValueProps {
  formData: TypeAny;
  user: TypeAny;
  fieldName: string;
}

export function fieldValue({ formData, user, fieldName }: FieldValueProps) {
  const hasFormData = typeof formData[fieldName] !== 'undefined';

  return hasFormData
    ? formData[fieldName]
    : user?.[fieldName] || user?.influencer?.shipping_address?.[fieldName];
}

export function compareKeysAndValues(
  obj1: { [key: string]: TypeAny },
  obj2: { [key: string]: TypeAny }
) {
  const keys1 = Object.keys(obj1);

  return keys1.every((key) => obj1[key] === obj2[key]);
}
